export default __webpack_public_path__ + "static/media/call.7aa295b5.svg";